import styled from 'styled-components';
import { Table, TableHead, TableBody, TableCell } from '@mui/material';

export const StyledTable = styled(Table)`
  border-collapse: collapse;
  width: 100%;
`;

export const StyledTableHead = styled(TableHead)`
  background-color: #f7f7f7;
`;

export const StyledTableBody = styled(TableBody)`
  background-color: white;
`;

export const StyledTableCell = styled(TableCell)`
  height: 40px;
  padding: 3px;
`;

export const PrivacyTag = styled.span`
  display: inline-flex;
  align-items: center;
  font-weight: bold;
  color: ${(props) => (props.privacy === 'Public' ? '#1dbf73' : '#ffb400')};
  background-color: ${(props) => (props.privacy === 'Public' ? '#e0f7ea' : '#fff4e5')};
  padding: 5px 10px;
  gap: 8px;
  border-radius: 20px;
  text-transform: uppercase;
`;
